import React from "react";

import {
  SkeletonButton,
  SkeletonCircle,
  SkeletonText,
} from "./SkeletonElements";

export const ProviderScheduleSkeleton: React.FC = () => {
  return (
    <div className="space-y-2">
      {/* Provider Header */}
      <div className="bg-light-lavender-gray/50 space-y-2 rounded-xl p-2 px-3">
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-3">
            <SkeletonCircle size="w-10 h-10" />
            <SkeletonText className="h-5 w-32" />
          </div>
          <SkeletonCircle size="w-6 h-6" />
        </div>
      </div>

      {/* Time Slots */}
      <div className="border-t border-gray-100 px-2 pb-4">
        <div className="mt-4 grid grid-cols-3 gap-2">
          {Array.from({ length: 6 }).map((_, slotIndex) => (
            <SkeletonButton key={slotIndex} className="h-10 w-full" />
          ))}
        </div>
      </div>
    </div>
  );
};
